import { Link as TRLink } from '@tanstack/react-router';
import * as runtime from 'react/jsx-runtime';

import {
  type AlertProps,
  Alert as GooeyAlert,
  Link as GooeyLink,
  type LinkProps as GooeyLinkProps,
} from 'gooey';

function ExternalLink(props: GooeyLinkProps) {
  return <GooeyLink {...props} target='_blank' rel='noopener noreferrer' />;
}

function Alert(props: AlertProps) {
  return <GooeyAlert {...props} variant={props.variant ?? 'outlined'} />;
}

const sharedComponents = {
  Alert: Alert,
  RouterLink: TRLink,
  ExternalLink: ExternalLink,
};

// parse the Velite generated MDX code into a React component function
const useMDXComponent = (code: string) => {
  const fn = new Function(code);
  return fn({ ...runtime }).default;
};

interface ContentMDXProps {
  code: string;
  components?: Record<string, React.ComponentType>;
}

export const ContentMDX = ({ code, components }: ContentMDXProps) => {
  const Component = useMDXComponent(code);
  return <Component components={{ ...sharedComponents, ...components }} />;
};
